<div
  [tabindex]="editable ? 0 : -1"
  [ngClass]="{
    focusable: editable,
    focused: isDialogOpen,
    invalid: !stateService.isAValidState && editable,
    disabled: !editable,
    hoverable: !isClearFilterEnabled,
  }"
  #wrapper
  class="miq-quarter-selector-wrapper"
>
  <div [class.editable]="editable" (click)="onElementClick()" class="miq-quarter-selector">
    <div *ngIf="!displayValueSet" class="placeholder">{{ placeholder }}</div>
    <div *ngIf="displayValueSet" class="value">{{ displayValue }}</div>
    <em *ngIf="displayClearButton" class="periodrange-clear pi pi-times-circle" (click)="clearFilter()"></em>
    <mat-icon [class.editable]="editable" svgIcon="calender-icon" class="calender-icon"></mat-icon>
  </div>
</div>
